import React, { Component } from 'react';
import { LoadingSpinner } from '@paypalcorp/pp-react-loading-spinner';
import withTheme from '../../components/withTheme';

class Spinner extends Component {
  render() {
    return <LoadingSpinner size="lg" />;
  }
}

export default withTheme(Spinner);
